// @flow

import _ from 'lodash';

import ViewConstants from 'constants/ViewConstants';

import ViewUtils from 'PMT/utils/ViewUtils';

export default class ColorPickerViewUtils {

  // --

  static getDefaultColorListUint() {
    const hexList = ViewConstants.ColorPicker.DEFAULT_COLORS_LIST;
    const uintList = [];

    _.each(hexList, (hexValue) => {
      uintList.push(ViewUtils.hexadecimalColorToUint(hexValue));
    });

    return uintList;
  }

}



// WEBPACK FOOTER //
// ./scripts/utils/ColorPickerViewUtils.js